<ng-container *ngrxLet="vm$ as vm">
    @if (vm) {
        @if (desktop) {
            <div class="targeted-promotions-layout row">
                <div class="col12 col-md-8">
                    <div class="row">
                        <div class="promohub-steps-wrapper">
                            <ul class="promohub-steps-container vertical static">
                                @for (step of vm?.howItWorksSteps; track step; let stepNo = $index) {
                                    @if (step?.title) {
                                        <li class="step">
                                            <div class="container">
                                                <div class="step-symbol">
                                                    <div class="symbol action">{{ stepNo + 1 }}</div>
                                                </div>
                                                <div class="step-content">
                                                    <div class="step-title">{{ step?.title }}</div>
                                                    <div class="step-text">{{ step?.description }}</div>
                                                </div>
                                            </div>
                                        </li>
                                    }
                                }
                            </ul>
                        </div>
                    </div>
                    <div class="ph-d-meta-data">
                        <details-meta-data [metaDataList]="vm?.dataPoints">
                            <details-page-datetime
                                detailsPageDateTime
                                [detailsPageValidity]="vm?.offersDetailsPageValidity"
                                [dsHighlight]="false"></details-page-datetime>
                        </details-meta-data>
                        @if (vm?.manualDataPoints?.length > 0) {
                            <details-meta-data [metaDataList]="vm?.manualDataPoints"></details-meta-data>
                        }
                    </div>
                    <base-details-terms-conditions
                        [detailsContent]="vm?.baseDetailsContent"
                        [viewType]="viewType"
                        [clientContent]="vm?.clientContentMessages">
                    </base-details-terms-conditions>
                </div>
                <div class="col12 col-md-4">
                    <tp-opt-in></tp-opt-in>
                    @if (vm?.displayPlayNow) {
                        <ng-content select="[playNow]"></ng-content>
                    }
                    <ng-content select="[criteria]"></ng-content>
                    <tp-rewards [rewardContent$]="rewardsContent$"></tp-rewards>
                    <multi-rewards-list></multi-rewards-list>
                    <ng-container *ngTemplateOutlet="secondaryRewardsTpl"></ng-container>
                </div>
            </div>
        }
        @if (!desktop) {
            <div class="targeted-promotions-layout">
                <div class="col">
                    <div class="promohub-steps-wrapper">
                        <ul class="promohub-steps-container vertical static">
                            @for (step of vm?.howItWorksSteps; track step; let stepNo = $index) {
                                @if (step?.title) {
                                    <li class="step">
                                        <div class="container">
                                            <div class="step-symbol">
                                                <div class="symbol action">{{ stepNo + 1 }}</div>
                                            </div>
                                            <div class="step-content">
                                                <div class="step-title">{{ step?.title }}</div>
                                                <div class="step-text">{{ step?.description }}</div>
                                            </div>
                                        </div>
                                    </li>
                                }
                            }
                        </ul>
                    </div>
                    <details-meta-data [metaDataList]="vm?.dataPoints">
                        <details-page-datetime detailsPageDateTime [detailsPageValidity]="vm?.offersDetailsPageValidity"></details-page-datetime>
                    </details-meta-data>
                    @if (vm?.manualDataPoints?.length > 0) {
                        <details-meta-data [metaDataList]="vm?.manualDataPoints"></details-meta-data>
                    }
                    <tp-rewards [rewardContent$]="rewardsContent$"></tp-rewards>
                    <multi-rewards-list></multi-rewards-list>
                    <ng-container *ngTemplateOutlet="secondaryRewardsTpl"></ng-container>
                    <base-details-terms-conditions
                        [detailsContent]="vm?.baseDetailsContent"
                        [viewType]="viewType"
                        [clientContent]="vm?.clientContentMessages">
                    </base-details-terms-conditions>
                    <tp-opt-in></tp-opt-in>
                </div>
            </div>
        }
    }
</ng-container>
